import React from 'react';
import classes from './Modal.css';
import Auxw from '../../../hoc/Auxw';
import Backdrop from '../Backdrop/Backdrop';


const modal = (props) => (
	<Auxw>
		<Backdrop show={props.show} clicked={props.modalClosed}/>
		<div
			className={classes.Modal}
			style={{
			transform: props.show ? 'translateY(0)' : 'translateY(-100vh)',
			opacity: props.show ? '1' : '0'
			}}>
			{props.children}
		</div>
	</Auxw>
);

export default modal;


// WEBPACK FOOTER //
// ./src/components/UI/Modal/Modal.js